module.exports = __webpack_public_path__ + "static/media/marcia.bcb0ea6f.jpg";